/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { arrayOf, date, DateFormat, entity, enumeration } from '@gh/core-data';
import { ContactType } from '../contacts';
import {
  CommunicationDataDto,
  CommunicationListItemDto,
  ActivityDetails,
  CommunicationType,
} from './communication.dto';
import { WithVersion } from '@gh/common-shared-data';

export const CommunicationListItemMapper = entity<CommunicationListItemDto>({
  communicationType: enumeration(CommunicationType),
  created: date(DateFormat.DateTime),
  startDate: date(DateFormat.DateTime),
  contactTypeCode: enumeration(ContactType),
});

export const CreateCommunicationActivityListItemMapper = entity<WithVersion<CommunicationListItemDto>>(
  {
    startDate: date(DateFormat.DateTime),
    endDate: date(DateFormat.DateTime),
    contactTypeCode: enumeration(ContactType),
  });

export const CommunicationDataMapper = entity<CommunicationDataDto>({
  communications: arrayOf(CommunicationListItemMapper),
});

export const CommunicationMeetingMapper = entity<ActivityDetails>({
  startDate: date(DateFormat.DateTime),
  endDate: date(DateFormat.DateTime),
  addedDate: date(DateFormat.DateTime),
});
